'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AudioPlayerView;

var _preact = require('preact');

var _paths = require('../../vendor/paths');

var audio = document.createElement('audio');

function AudioPlayerView(props) {
  if (props.file) {
    document.body.style.backgroundImage = 'url(' + (0, _paths.pngpath)(props.file) + ')';
    audio.src = (0, _paths.mp3path)(props.file);
    audio.currentTime = 0;
    audio.play();
    return (0, _preact.h)(
      'div',
      { 'class': 'audioPlayer', onClick: function onClick() {
          return audio.paused ? audio.play() : audio.pause();
        } },
      'Playing ',
      props.file.name
    );
  } else {
    audio.pause();
    return (0, _preact.h)(
      'div',
      { 'class': 'audioPlayer' },
      'Not Playing'
    );
  }
}


//////////////////
// WEBPACK FOOTER
// ./client/components/UI/AudioPlayerView.jsx
// module id = 71
// module chunks = 0